var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoaching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19C9.33333 19 7.91667 18.4167 6.75 17.25C5.58333 16.0833 5 14.6667 5 13C5 12.8167 5.00833 12.6333 5.025 12.45C5.04167 12.2667 5.06667 12.0833 5.1 11.9C5.01667 11.9333 4.91667 11.9583 4.8 11.975C4.68333 11.9917 4.58333 12 4.5 12C3.8 12 3.20833 11.7583 2.725 11.275C2.24167 10.7917 2 10.2 2 9.5C2 8.8 2.22917 8.20833 2.6875 7.725C3.14583 7.24167 3.725 7 4.425 7C4.975 7 5.47083 7.15417 5.9125 7.4625C6.35417 7.77083 6.66667 8.16667 6.85 8.65C7.4 8.15 8.02917 7.75 8.7375 7.45C9.44583 7.15 10.2 7 11 7H22V11H17V13C17 14.6667 16.4167 16.0833 15.25 17.25C14.0833 18.4167 12.6667 19 11 19ZM4.5 10.5C4.78333 10.5 5.02083 10.4042 5.2125 10.2125C5.40417 10.0208 5.5 9.78333 5.5 9.5C5.5 9.21667 5.40417 8.97917 5.2125 8.7875C5.02083 8.59583 4.78333 8.5 4.5 8.5C4.21667 8.5 3.97917 8.59583 3.7875 8.7875C3.59583 8.97917 3.5 9.21667 3.5 9.5C3.5 9.78333 3.59583 10.0208 3.7875 10.2125C3.97917 10.4042 4.21667 10.5 4.5 10.5ZM11 16.5C11.9667 16.5 12.7917 16.1583 13.475 15.475C14.1583 14.7917 14.5 13.9667 14.5 13C14.5 12.0333 14.1583 11.2083 13.475 10.525C12.7917 9.84167 11.9667 9.5 11 9.5C10.0333 9.5 9.20833 9.84167 8.525 10.525C7.84167 11.2083 7.5 12.0333 7.5 13C7.5 13.9667 7.84167 14.7917 8.525 15.475C9.20833 16.1583 10.0333 16.5 11 16.5ZM11 15C11.55 15 12.0208 14.8042 12.4125 14.4125C12.8042 14.0208 13 13.55 13 13C13 12.45 12.8042 11.9792 12.4125 11.5875C12.0208 11.1958 11.55 11 11 11C10.45 11 9.97917 11.1958 9.5875 11.5875C9.19583 11.9792 9 12.45 9 13C9 13.55 9.19583 14.0208 9.5875 14.4125C9.97917 14.8042 10.45 15 11 15Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoaching);
export default __webpack_public_path__ + "static/media/Coaching.b7141b8f.svg";
export { ForwardRef as ReactComponent };